import { LegalLayout } from "@/components/legal-layout";
const SplitComponent = LegalLayout;
export { SplitComponent as component };